"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// COLORS
const style = "normal";
const brand = "#00ACC8";
const headerTextColor = brand;
const headerBackgroundColor = "#FFFFFF";
const mainInfoLandscape = headerTextColor;
const mainInfoPortrait = headerTextColor;
const fontFamily = `
@font-face {
  font-family: 'TUIType';
  src: url('/fonts/tuitype/TUIType-LATN-W/TUIType.eot');
  src: url('/fonts/tuitype/TUIType-LATN-W/TUIType.eot?#iefix') format('embedded-opentype'),
       url('/fonts/tuitype/TUIType-LATN-W/TUIType.woff') format('woff'),
       url('/fonts/tuitype/TUIType-LATN-W/TUIType.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'TUIType';
  src: url('/fonts/tuitype/TUIType-Bold-LATN-W/TUIType.eot');
  src: url('/fonts/tuitype/TUIType-Bold-LATN-W/TUIType.eot?#iefix') format('embedded-opentype'),
       url('/fonts/tuitype/TUIType-Bold-LATN-W/TUIType.woff') format('woff'),
       url('/fonts/tuitype/TUIType-Bold-LATN-W/TUIType.ttf') format('truetype');
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: 'TUIType';
  src: url('/fonts/tuitype/TUIType-Light-LATN-W/TUIType.eot');
  src: url('/fonts/tuitype/TUIType-Light-LATN-W/TUIType.eot?#iefix') format('embedded-opentype'),
       url('/fonts/tuitype/TUIType-Light-LATN-W/TUIType.woff') format('woff'),
       url('/fonts/tuitype/TUIType-Light-LATN-W/TUIType.ttf') format('truetype');
  font-weight: 200;
  font-style: normal;
}
html {
    font-family: "TUIType", sans-serif;
}
`;
exports.default = {
    brand,
    mainInfoLandscape,
    mainInfoPortrait,
    headerTextColor,
    headerBackgroundColor,
    fontFamily,
    style,
};
